import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useStore, extractErrorMessage } from "../../../helpers";

export const useDeleteNotebook = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const res = await rootStore.apiRequestHandler(
        "tars/notebooks/delete",
        { notebook_id: id },
        "Failed to delete notebook"
      );
      return res;
    },
    onSuccess: () => {
      toast.success("Notebook deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["notebooks"] });
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to delete notebook"));
    },
  });
};
